export default "__VITE_ASSET__UuBuXUcT__"